import { render, staticRenderFns } from "./AxMonitorSelectAdministratorDialog.vue?vue&type=template&id=fb345620&scoped=true"
import script from "./AxMonitorSelectAdministratorDialog.vue?vue&type=script&lang=ts"
export * from "./AxMonitorSelectAdministratorDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxMonitorSelectAdministratorDialog.vue?vue&type=style&index=0&id=fb345620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb345620",
  null
  
)

export default component.exports